import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'GroupsModuleContainer'

    static propTypes = {
      createdGroup: PropTypes.number,
      getGroups: PropTypes.func.isRequired,
      groups: PropTypes.array.isRequired,
      groupsDone: PropTypes.bool.isRequired,
      groupsError: PropTypes.bool.isRequired,
      groupsPending: PropTypes.bool.isRequired,
      redirectToNewGroup: PropTypes.func.isRequired,
      setPage: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      showCreateGroupModal: PropTypes.func.isRequired,
      toggleLimit: PropTypes.func.isRequired,
      toggleSortOrder: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { getGroups, groupsDone } = this.props

      if (!groupsDone) {
        getGroups()
      }
    }

    componentDidUpdate() {
      const { createdGroup, redirectToNewGroup } = this.props

      if (createdGroup) {
        redirectToNewGroup(createdGroup)
      }
    }

    setPage = page => {
      const { setPage } = this.props

      setPage(page)
      window.scrollTo(0, 0)
    }

    render() {
      const { groups, groupsError, groupsPending } = this.props

      return (
        <WrappedComponent
          groups={groups}
          hasError={groupsError}
          loaderPending={groupsPending && !groupsError}
          setPage={this.setPage}
          {...this.props}
        />
      )
    }
  }

  return Container
}
